import React from 'react';
import './Footer.css';
import { Twitter, Linkedin, Instagram, Youtube } from 'lucide-react';

const Footer = () => {
  const scrollTo = (selector) => (e) => {
    e.preventDefault();
    // Try selector first (id or class), then fallback to registration page
    try {
      const el = document.querySelector(selector);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    } catch (err) {
      // ignore
    }
    // Fallbacks for logical pages
    if (selector === '/registration') {
      window.location.href = '/registration';
      return;
    }
    // default fallback to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="site-footer">
    <div className="footer-wrap">
      <div className="brand-col">
        <div className="logo">Expert Supply Chain Logistics LLC</div>
        <div className="contact-lines">
          <a className="small" href="tel:+14704068861" aria-label="Call Expert Supply Chain">+1 (470) 406-8861</a>
          <a className="small" href="mailto:muradkoket@gmail.com" aria-label="Email Expert Supply Chain">muradkoket@gmail.com</a>
        </div>
      </div>

      <nav className="links-col">
        <div className="col">
          <div className="col-title">SERVICES</div>
          <a href="#about" onClick={scrollTo('.hero-container')}>About</a>
          <a href="/registration" onClick={scrollTo('/registration')}>Request Quote</a>
          <a href="#features" onClick={scrollTo('#features-section')}>Freight Options</a>
        </div>

        <div className="col">
          <div className="col-title">REGIONS</div>
          <a href="#southeast" onClick={scrollTo('.solution-features-section')}>Southeast</a>
          <a href="#midwest" onClick={scrollTo('.solution-features-section')}>Midwest</a>
          <a href="#northeast" onClick={scrollTo('.solution-features-section')}>Northeast</a>
        </div>

        <div className="col">
          <div className="col-title">RESOURCES</div>
          <a href="#faq" onClick={scrollTo('.faq-section')}>FAQs</a>
        </div>
      </nav>

      <div className="social-col">
        <a href="#" aria-label="Twitter"><Twitter size={18} /></a>
        <a href="#" aria-label="LinkedIn"><Linkedin size={18} /></a>
        <a href="#" aria-label="Instagram"><Instagram size={18} /></a>
        <a href="#" aria-label="YouTube"><Youtube size={18} /></a>
      </div>
    </div>

    <div className="footer-bottom">
      <div>© 2026 Expert Supply Chain Logistics LLC</div>
      <div className="footer-links">
        <a href="/terms">Site Terms</a>
        <a href="/privacy">Privacy Policy</a>
      </div>
    </div>
  </footer>
);

}

export default Footer;
